<template>
  <v-row>
    <v-dialog v-model="visible" persistent max-width="900px">
      <v-card :loading="loading">
        <v-card-title>
          <span class="headline">{{ $t("modal.multiResolution.title") }}</span>
        </v-card-title>

        <v-card-subtitle>
          <b>{{ totalSelectedCases }}</b> cases will be updated.
        </v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-select
                label="Status"
                dense
                v-model="status"
                :items="reportStatusesSelect"
                item-text="title"
                item-value="code"
              />
              <!-- <v-btn-toggle dense rounded v-model="resolutionStatus">
                <v-btn
                  width="130"
                  outlined
                  color="green"
                  elevation="1"
                  value="R"
                >
                  {{ $t("modal.caseReport.label.approve") }}
                  <v-icon color="green" right>mdi-check</v-icon>
                </v-btn>
                <v-btn width="130" outlined color="red" elevation="1" value="F">
                  {{ $t("modal.caseReport.label.flag") }}
                  <v-icon color="red" right class="mr-1">mdi-alert</v-icon>
                </v-btn>
              </v-btn-toggle> -->
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="comment"
                :placeholder="$t('modal.multiResolution.label.commentOptional')"
                dense
                rows="1"
                counter
                maxlength="500"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="onCancel">{{
            $t("label.cancel")
          }}</v-btn>
          <v-btn
            :disabled="status == null"
            color="blue darken-1"
            @click="updateStatus"
            :loading="loading"
            >{{ $t("label.save") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { reportStatusesSelect } from "../../utils/reportStatuses";
export default {
  name: "MultiResolution",
  data() {
    return {
      reportStatusesSelect,
      status: null,
      comment: "",
    };
  },
  props: {
    error: {},
    totalSelectedCases: Number,
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible: function(val){
      if(!val){
        this.status = null;
        this.comment = null;
      }
    }
  },
  methods: {
    updateStatus() {
      this.$emit("onConfirm", this.status, this.comment);
    },
    onCancel() {
      this.$emit("onCancelled");
    },
  },
  created: function () {
  },
};
</script>